module.exports = __webpack_public_path__ + "img/oxford1.6ce4f32d.png";